import {useEffect} from 'react'

/**
 * Imperatively styles the global page footer (`footer.footer`) with a top
 * border and compact vertical padding when `enabled` is `true`. Cleans up
 * on unmount or when `enabled` flips to `false`.
 */
export function useFooterBorder(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return
    const footer: HTMLElement | null = document.querySelector('footer.footer')
    if (!footer) return

    footer.style.setProperty('border-top', 'var(--borderWidth-thin) solid var(--borderColor-default)')
    footer.style.setProperty('padding', 'var(--base-size-16) 0', 'important')

    return () => {
      footer.style.removeProperty('border-top')
      footer.style.removeProperty('padding')
    }
  }, [enabled])
}
